import styled from 'styled-components'

export const StyledNewsArticlePdfExportModal = styled.div`
  .pdfViewerStyle {
    width: 1000px;
    height: 800px;
  }
`
